export var RichTextEditorErrorMessage;
(function (RichTextEditorErrorMessage) {
    RichTextEditorErrorMessage["noError"] = "";
    RichTextEditorErrorMessage["startUrl"] = "Rte:StartUrlErrorMessage";
})(RichTextEditorErrorMessage || (RichTextEditorErrorMessage = {}));
